import React, { useEffect, useReducer, useState } from "react";

import Table from "./partials/Table";
import FilterForm from "./partials/FilterForm";
import Summary from "./partials/Summary";

export const Context = React.createContext(null);

const pad2 = (n) => String(n).padStart(2, "0");

const formatDateInput = (date) =>
  `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`;

const getDefaultDateRange = () => {
  const from = new Date();
  from.setDate(from.getDate());

  const to = new Date(from);
  to.setDate(to.getDate() + 6);

  return {
    fromDate: formatDateInput(from),
    toDate: formatDateInput(to),
  };
};

const DEFAULT_DATE_RANGE = getDefaultDateRange();

const initialFilterData = {
  channel: "",
  numbers: "",
  ticketCode: "",
  ticketType: "all",
  fromDate: DEFAULT_DATE_RANGE.fromDate,
  toDate: DEFAULT_DATE_RANGE.toDate,
  filterPressCount: 0,
  isLoading: false,
};

const reducer = (state, action) => {
  switch (action.type) {
    case "SUBMIT_FILTER":
      return {
        ...state,
        ...action.payload,
        filterPressCount: state.filterPressCount + 1,
      };
    case "SET_LOADING":
      return {
        ...state,
        isLoading: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

const SalesTicketStorage = ({ region: regionProp }) => {
  const [selectedRegion, setSelectedRegion] = useState(regionProp || "MN");
  var [state, dispatch] = useReducer(reducer, initialFilterData);

  const region = regionProp || selectedRegion;

  useEffect(() => {
    if (regionProp) {
      document.title =
        regionProp === "MN"
          ? "Quản lí vé miền Nam"
          : regionProp === "MT"
            ? "Quản lí vé miền Trung"
            : "Quản lí vé miền Bắc";
    } else {
      document.title = "Quản lí vé";
    }
  }, [regionProp]);

  return (
    <Context.Provider
      value={{
        state,
        dispatch,
      }}
    >
      <div className="py-4">
        <FilterForm
          region={region}
          showRegionSelect={!regionProp}
          selectedRegion={selectedRegion}
          onRegionChange={setSelectedRegion}
        />

        <Summary region={region} />

        <Table region={region} />
      </div>
    </Context.Provider>
  );
};

export default SalesTicketStorage;
